export enum TaskColumn {
    NAME = "name",
    DUE_DATE = "dueDate",
    ESTIMATE = "estimate",
    GROUP = "group",
    ACTIONS = "actions",
    ENTITIES = "entities",
    ASSIGNEE = "assignee",
    PRIORITY = "priority",
    STATUS = "status",
    CREATED_AT = "createdAt",
    CREATED_BY = "createdBy",
    UPDATED_AT = "updatedAt",
    CLOSE_STAGE = "closeStage",
    CLOSE = "orgClose",
    SERVICE_PERIOD = "servicePeriod",
    VISIBILITY = "visibility",
    COMPLETED_BY = "completedBy",
    COMPLETED_AT = "completedAt",
    CLIENT = "client",
}

export enum TaskSortValue {
    NAME_ASC = "NAME_ASC",
    NAME_DESC = "NAME_DESC",
    DUE_DATE_ASC = "DUE_DATE_ASC",
    DUE_DATE_DESC = "DUE_DATE_DESC",
    ESTIMATE_ASC = "ESTIMATE_ASC",
    ESTIMATE_DESC = "ESTIMATE_DESC",
    PRIORITY_ASC = "PRIORITY_ASC",
    PRIORITY_DESC = "PRIORITY_DESC",
    STATUS_ASC = "STATUS_ASC",
    STATUS_DESC = "STATUS_DESC",
    CREATED_AT_ASC = "CREATED_AT_ASC",
    CREATED_AT_DESC = "CREATED_AT_DESC",
    CREATED_BY_ASC = "CREATED_BY_ASC",
    CREATED_BY_DESC = "CREATED_BY_DESC",
    ASSIGNEE_ASC = "ASSIGNEE_ASC",
    ASSIGNEE_DESC = "ASSIGNEE_DESC",
    UPDATED_AT_ASC = "UPDATED_AT_ASC",
    UPDATED_AT_DESC = "UPDATED_AT_DESC",
    COMPLETED_AT_ASC = "COMPLETED_AT_ASC",
    COMPLETED_AT_DESC = "COMPLETED_AT_DESC",
    COMPLETED_BY_ASC = "COMPLETED_BY_ASC",
    COMPLETED_BY_DESC = "COMPLETED_BY_DESC",
    CLIENT_ASC = "CLIENT_ASC",
    CLIENT_DESC = "CLIENT_DESC",
}
